// Охранный бот (deus_ohrannyy_bot, common) — EOT-trigger.
// Если у Героя владельца есть броня (current.armor > 0) → +1 HP этому юниту (постоянный, может превышать max).

export const CARD_ID = 'deus_ohrannyy_bot';

export function ohrannyyBotEot(state, ownerIdx, card) {
  const p = state.players[ownerIdx];
  if (!p || !card.isAlive()) return;
  if (p.hero.armor > 0) {
    card.current.hp += 1;
    state.log.add(`🛡 Охранный бот [${p.name}]: у Героя есть броня → +1 HP (HP=${card.current.hp})`);
  }
}
